import { FunctionComponent } from 'react'
import PostCategories from './postCategories'
import profileStyles from '../DaycareProfileHandler.module.scss'

interface NewsSettingsProps {
    daycareId: number
}

const NewsSettings: FunctionComponent<NewsSettingsProps> = ({ daycareId }: NewsSettingsProps) => {
    return (
        <div className={profileStyles.PagePosition}>
            <PostCategories daycareId={daycareId} />
        </div>
    )
}

export default NewsSettings
